<template>
    <section class="pb-0 pb-lg-4" style="background-color: #f2f2f2;">
 
 <div class="container">
   <div class="row">
     <div class="col-lg-3 col-md-7 col-12 mb-4 mb-md-6 mb-lg-0 order-0"> <img class="mb-4" src="../../assets/img/logo1.png" width="150" alt="jadoo" />
       <p class="fs--1 text-secondary mb-0 fw-medium">Book your trip in minute, get full Control for much longer.</p>
     </div>
     <!-- <div class="col-lg-2 col-md-4 mb-4 mb-lg-0 order-lg-1 order-md-2">
       <h4 class="footer-heading-color fw-bold font-sans-serif mb-3 mb-lg-4">Company</h4>
       <ul class="list-unstyled mb-0">
         <li class="mb-2"><a class="link-900 fs-1 fw-medium text-decoration-none" href="#!">About</a></li>
         <li class="mb-2"><a class="link-900 fs-1 fw-medium text-decoration-none" href="#!">Careers</a></li>
         <li class="mb-2"><a class="link-900 fs-1 fw-medium text-decoration-none" href="#!">Mobile</a></li>
       </ul>
     </div> -->
     <!-- <div class="col-lg-2 col-md-4 mb-4 mb-lg-0 order-lg-2 order-md-3">
       <h4 class="footer-heading-color fw-bold font-sans-serif mb-3 mb-lg-4">Contact</h4>
       <ul class="list-unstyled mb-0">
         <li class="mb-2"><a class="link-900 fs-1 fw-medium text-decoration-none" href="#!">Help/FAQ</a></li>
         <li class="mb-2"><a class="link-900 fs-1 fw-medium text-decoration-none" href="#!">Press</a></li>
         <li class="mb-2"><a class="link-900 fs-1 fw-medium text-decoration-none" href="#!">Affiliate</a></li>
       </ul>
     </div> -->
     <!-- <div class="col-lg-2 col-md-4 mb-4 mb-lg-0 order-lg-3 order-md-4">
       <h4 class="footer-heading-color fw-bold font-sans-serif mb-3 mb-lg-4">More</h4>
       <ul class="list-unstyled mb-0">
         <li class="mb-2"><a class="link-900 fs-1 fw-medium text-decoration-none" href="#!">Airlinefees</a></li>
         <li class="mb-2"><a class="link-900 fs-1 fw-medium text-decoration-none" href="#!">Airline</a></li>
         <li class="mb-2"><a class="link-900 fs-1 fw-medium text-decoration-none" href="#!">Low fare tips</a></li>
       </ul>
     </div> -->
     <!-- <div class="col-lg-3 col-md-5 col-12 mb-4 mb-md-6 mb-lg-0 order-lg-4 order-md-1">
       <div class="icon-group mb-4"> <a class="text-decoration-none icon-item shadow-social" id="facebook" href="#!"><i class="fab fa-facebook-f"> </i></a><a class="text-decoration-none icon-item shadow-social" id="instagram" href="#!"><i class="fab fa-instagram"> </i></a><a class="text-decoration-none icon-item shadow-social" id="twitter" href="#!"><i class="fab fa-twitter"> </i></a></div>
       <h4 class="fw-medium font-sans-serif text-secondary mb-3">Discover our app</h4>
       <div class="d-flex align-items-center"> <a href="#!"> <img class="me-2" src="../../assets/img/play-store.png" alt="play store" /></a><a href="#!"> <img src="../../assets/img/apple-store.png" alt="apple store" /></a></div>
     </div> -->
   </div>
 </div><!-- end of .container-->
 
 </section>
 
 <div class="py-3 text-center">
         <p class="mb-0 text-secondary fs--1 fw-medium">All rights reserved@TimeFixed.com </p>
       </div>
 </template>
 
 <script>
 export default {
  name : 'FooterPage'
 }
 </script>
 
 <style>
 
 </style>